<script lang="ts">
    import { Font, FontTypes } from '@uikit/font';
    import { SvgIcon } from '@uikit/svg-icon';
    import { Color, type IconData } from '@uikit/svg-icon/types';

    import s from './empty-list.module.css';

    export let icon: IconData;
    export let emptyTitle: string;
    export let emptySubtitle: string;
</script>

<div class={s.emptyRoot}>
    <SvgIcon {icon} width={60} color={Color.secondary}/>
    <div class={s.emptyText}>
        <Font
            type={FontTypes.Type.h4}
            tagName={FontTypes.TagName.div}
            color={FontTypes.Color.Secondary}
            isBold
        >
            {emptyTitle}
        </Font>
        <Font
            type={FontTypes.Type.body}
            tagName={FontTypes.TagName.div}
            color={FontTypes.Color.Secondary}
            className={s.emptyDescription}
        >
            {emptySubtitle}
        </Font>
    </div>
</div>
